import { Space } from 'antd';
import { useContext } from 'react';

import {
  CLIENTS_FILTER,
  FEMALE_ID,
  FEMALE_LABEL,
  MALE_ID,
  MALE_LABEL,
  UNKNOWN_LABEL,
} from '@app/constants';
import { CHF_GENDER } from '@app/pages/Clients/ClientsList/constants/filterKeysAndIds';
import { ClientFiltersContext } from '@app/providers';
import { generateKey } from '@app/utils';

import { ClientFilterTag } from '@pages/Clients/ClientsList/components/Filters/ClientFilterTag';

export const ClientsGenderLabel = ({
  includedFiltersIndex,
}: {
  includedFiltersIndex: number;
}) => {
  const { filters, serverFilters, setFilters, setServerFilters } =
    useContext(ClientFiltersContext);

  const data =
    serverFilters.ClientsFilter?.[includedFiltersIndex]?.Values?.[0]?.Gender;

  return (
    <Space
      className={`clients-gender-label${includedFiltersIndex}`}
      direction="vertical"
    >
      <span>Пол</span>
      {data && (
        <>
          {data.map((item) => {
            let result: string;

            switch (item) {
              case FEMALE_ID:
                result = FEMALE_LABEL;
                break;
              case MALE_ID:
                result = MALE_LABEL;
                break;
              case null:
              default:
                result = UNKNOWN_LABEL;
                break;
            }

            return (
              <div key={generateKey('ClientFilterTag', `${item}`)}>
                <ClientFilterTag
                  filters={filters}
                  serverFilters={serverFilters}
                  filtersArea={CLIENTS_FILTER}
                  filterGroupIndex={includedFiltersIndex}
                  setFilters={setFilters}
                  setServerFilters={setServerFilters}
                  valueKey={CHF_GENDER}
                >
                  {result}
                </ClientFilterTag>
              </div>
            );
          })}
        </>
      )}
    </Space>
  );
};
